// Experiment : /features/trees/newpersonhints
export const ALLOW_ACCESS = 'allow';
export const ALLOW_SHOW = 'allow_show';
export const DENY_ACCESS = 'deny';
export const LIMITED_ACCESS_FREE_TRIAL_PENDING = 'NO_ACCESS_FREE_TRIAL_PENDING';
export const LIMITED_ACCESS_FREE_TRIAL_USED = 'NO_ACCESS_FREE_TRIAL_USED';
export const NPH_GATED_VIEW_STATUS = new Set([LIMITED_ACCESS_FREE_TRIAL_PENDING, LIMITED_ACCESS_FREE_TRIAL_USED]);

export const METERING_NPH_AUTH_FEATURE = '/features/hints/newpersonhints';
export const AuthViewTypes = {
	AllowShow: 'allow_show',
	DenyUpsell: 'deny_upsell'
};
